import { useContext } from 'react';

import { DictationRuntimeContext } from '../runtimeContext';
import type { DictationRuntime } from '../types';

export function useDictationRuntime(): DictationRuntime | null {
  return useContext(DictationRuntimeContext);
}
